<template>
    <tr
        class="kgr-table__row"
    >
        <td
            v-if="isBulkInvoiceOperation"
            class="kgr-table__cell"
        >
        </td>
        <td class="kgr-table__cell">
        </td>
        <td
            class="kgr-table__cell"
        >
            <kgr-icon
                style="margin-bottom: -5px; margin-left: 15px;"
                icon-class="arrow-forward"
                disabled
                small
            />
            {{ $t('Rücklastschrift') }} <span style="color:red;">{{ formatMoney }}</span>
        </td>
        <td class="kgr-table__cell">
        </td>
        <td class="kgr-table__cell">
        </td>
        <td class="kgr-table__cell">
        </td>
        <td class="kgr-table__cell">
            {{ formatAppliedAtAndReason }}
        </td>
        <td class="kgr-table__cell">
            <span style="float:right">
                <kgr-invoice-chargeback-pdf-button
                    :invoice="invoice"
                    @reloadInvoice="emitReloadInvoiceWithPolling()"
                />
                <kgr-invoice-chargeback-email-button
                    :invoice="invoice"
                    @sendChargeback="$emit('sendChargeback')"
                />
                <button
                    class="kgr-table__action"
                    :disabled="deleteDisabled"
                    @click="deleteChargeback(invoice.id)"
                >
                    <kgr-icon
                        :title="$t('Rücklastschriftgebühr löschen')"
                        icon-class="delete"
                        :disabled="deleteDisabled"
                    />
                </button>

            </span>
        </td>
    </tr>
</template>

<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import ClubInvoiceRepository from '../../../js/repository/ClubInvoiceRepository.js';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';
import InvoiceChargebackEmailButton from './InvoiceChargebackEmailButton.vue';
import InvoiceChargebackPdfButton from './InvoiceChargebackPdfButton.vue';
import Money from '../../../js/dto/Money.js';

export default {
    name: 'InvoiceChargeback',
    components: {
        'kgr-icon': Icon,
        'kgr-invoice-chargeback-email-button': InvoiceChargebackEmailButton,
        'kgr-invoice-chargeback-pdf-button': InvoiceChargebackPdfButton,
    },
    props: {
        invoice: {
            type: ClubInvoice,
            required: true,
        },
        isBulkInvoiceOperation:{
            type: Boolean,
            required: false,
            default:false
        }
    },
    data() {
        return {
            helper: new Helper(),
        }
    },
    computed: {
        deleteDisabled() {
            return !this.invoice.chargeback.pdfExists
        },
        formatAppliedAtAndReason() {
            let text = 'Erstellt: ' + this.helper.formatDate(this.invoice.chargeback.createdAt);
            if (null !== this.invoice.chargeback.reason) {
                text += ' (' + this.helper.translateChargebackReason(this.invoice.chargeback.reason) + ')';
            }
            return text;
        },
        formatMoney() {
            if (null !== this.invoice.chargeback.clubFee) {
                return ' (' + Money.fromData(this.invoice.chargeback.amount).toLocalizedString()
                    + ' ' + this.invoice.chargeback.amount.currency
                    + ' - ' + this.invoice.chargeback.clubFee + ')';
            }
            return '';
        },
    },
    methods: {
        deleteChargeback(invoiceId) {
            showConfirm(this.$t('confirmInformal'), this.getDeleteConfirmationText(), () => {
                ClubInvoiceRepository.deleteChargeback(invoiceId)
                    .then(() => this.emitReloadInvoice())
                    .catch(() => this.$notify.error('saveChanges.error'));
            }, this.$t('Löschen'));
        },
        emitReloadInvoice() {
            this.$emit('reloadInvoice');
        },
        emitReloadInvoiceWithPolling() {
            this.$emit('reloadInvoiceWithPolling');
        },
        getDeleteConfirmationText() {
            const text = 'Möchtest Du die Rücklastschrift für die Rechnung #' + this.invoice.number + ' wirklich rückgängig machen?<br>'
            if(this.invoice.chargeback.clubFee !== null) {
                return text + 'Das PDF, die Rücklastschriftgebühr und die Rücklastschriftzahlung werden gelöscht';
            }
            return text + 'Das PDF und die Rücklastschriftzahlung werden gelöscht.';
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
